import ShareableLink from './ShareableLink.router';

export default ShareableLink;
